import matches from 'validator/lib/matches';
import isEmpty from 'validator/lib/isEmpty';
import { createField, updateField } from '../../actions';
import { EVENT_STEP_VALIDATE } from '../../helpers/consts';

export class TelField {
    constructor(options) {
        this.validateMessages = {
            telephoneBlock: __('This does not look like a telephone number. Is this correct?'),
            telephoneBlockFake: __('Those are many consecutive numbers, say. Is that right?'),
            telephoneWarningNoFakeData: __('This number seems to be incorrect. Try again'),
            telephoneMinAmountOfCharacters: __('It seems like something is missing. Is your telephone number correct?'),
            telephoneNoWeirdCharacters: __('Your number contains symbols that we do not understand. Is that right?'),
            noHTMLAllowed: __('No HTML allowed'),
            noCountriesAllowedBasedOnPhoneCountryCode: __('Exact is not available in your country'),
        };
        this.store = options.store;
        this.state = this.store.getState();
        this.$context = options.$context;
        this.id = options.id;
        this.label = options.label;
        this.required = options.required !== undefined ? options.required : true;
        this.stepId = options.stepId
        const fieldState = this.state.formFields.find(field => field.id === this.id );
        this.value = (fieldState && fieldState.value) ? fieldState.value : '';
        this.isValid = false;
        this.$el = this.createFieldElement();

        if (this.value !== '') {
            this.validate();
        }
    }

    createFieldElement () { // eslint-disable-line class-methods-use-this
        let debounceTimeout;
        const $field = document.createElement('div');
        const $fieldLabel = document.createElement('label');
        this.$fieldInput = document.createElement('input');
        this.$fieldMessage = document.createElement('span');

        this.$fieldInput.type = 'tel';
        this.$fieldInput.id = this.id;
        this.$fieldInput.required = this.required;
        this.$fieldInput.value = this.value;
        $fieldLabel.setAttribute('for', this.id);
        $fieldLabel.innerHTML = this.label;

        $field.classList.add('field', 'form-group', 'field--tel')
        $fieldLabel.classList.add('field-label');
        this.$fieldInput.classList.add('field-input', 'form-control', 'field-input--tel');
        this.$fieldMessage.classList.add('invalid-feedback');

        $field.appendChild($fieldLabel);
        $field.appendChild(this.$fieldInput);
        $field.appendChild(this.$fieldMessage);

        this.store.dispatch(createField(this.id, this.label, this.stepId));
        this.$fieldInput.addEventListener('blur', () => {
            this.validate.bind(this)
        });
        this.$fieldInput.addEventListener('input', () => {
            if (this.$fieldInput.value.length > 9 || this.$fieldInput.value.length === 0 || this.isValid) {
                clearTimeout(debounceTimeout);
                debounceTimeout = setTimeout(this.validate.bind(this), 100);
            }
        });

        return $field;
    }

    validate() {
        this.$fieldInput.classList.remove('is-valid');
        this.$fieldInput.classList.remove('is-invalid');
        this.isValid = false;

        if(matches(this.$fieldInput.value, /((0{7,}|1{7,}|2{7,}|3{7,}|4{7,}|5{7,}|6{7,}|7{7,}|8{7,}|9{7,}))+/g)) {
            // No block of fake repeating numbers
            this.$fieldInput.classList.add('is-invalid')
            this.$fieldMessage.innerHTML = this.validateMessages.telephoneBlockFake;
        } else if(matches(this.$fieldInput.value, /((1234567|09876543|34052923|123456789).)+/g)) {
            // No fake data
            this.$fieldInput.classList.add('is-invalid')
            this.$fieldMessage.innerHTML = this.validateMessages.telephoneWarningNoFakeData;
        } else if(matches(this.$fieldInput.value, /([^0-9+\s/.-])+/g)) {
            // No weird characters
            this.$fieldInput.classList.add('is-invalid')
            this.$fieldMessage.innerHTML = this.validateMessages.telephoneBlock;
        } else if(matches(this.$fieldInput.value, /((#|@|%|!|&|=|>|<|,|[a-zA-Z]).)+/g)) {
            // No weird characters
            this.$fieldInput.classList.add('is-invalid')
            this.$fieldMessage.innerHTML = this.validateMessages.telephoneNoWeirdCharacters;
        } else if(matches(this.$fieldInput.value, /<[^>]*>/g)) {
            // No html allowed
            this.$fieldInput.classList.add('is-invalid')
            this.$fieldMessage.innerHTML = this.validateMessages.noHTMLAllowed;
        } else if(matches(this.$fieldInput.value, /^((0020|0021|0023|0024|0025|0026|0027|0029|\+20|\+21|\+23|\+24|\+25|\+26|\+27|\+29).)/g)) {
            // Some countries are not allowed.
            this.$fieldInput.classList.add('is-invalid')
            this.$fieldMessage.innerHTML = this.validateMessages.noCountriesAllowedBasedOnPhoneCountryCode;
        } else if(!matches(this.$fieldInput.value, /^.{9,}$/g)) {
            // Min number of charcters
            this.$fieldInput.classList.add('is-invalid')
            this.$fieldMessage.innerHTML = this.validateMessages.telephoneMinAmountOfCharacters;
        } else if(matches(this.$fieldInput.value, /\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}/g)) {
            this.$fieldInput.classList.remove('is-invalid');
            this.$fieldInput.classList.add('is-valid');
            this.isValid = true;
        } else {
            this.$fieldInput.classList.add('is-invalid');
            this.$fieldInput.classList.remove('is-valid');
            this.$fieldMessage.innerHTML = this.validateMessages.telephoneWarningNoFakeData;
            this.isValid = false;
        }

        if(isEmpty(this.$fieldInput.value)) {
            this.$fieldInput.classList.remove('is-invalid');
            this.$fieldInput.classList.remove('is-valid');
            this.isValid = false;

            if (this.required) {
                this.$fieldInput.classList.add('is-invalid');
            }
        }

        if (this.isValid) {
            this.store.dispatch(updateField(this.id, this.$fieldInput.value, this.isValid, this.label));
        }
        this.$context.dispatchEvent(EVENT_STEP_VALIDATE);
    }

    valid() {
        return this.isValid;
    }

    render() {
        return this.$el;
    }
}

export default TelField;
